import React from 'react'
import { connect } from 'react-redux'
import { getSafe } from '@/helpers/global';
import { getPortfolioAction } from '@/actions/trading'
import { Icons } from '@/configurations';
import TabHeader from '@/components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import PositionProportionEChart from './PositionProportionEChart';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import { openMarketPositionProportion } from '@/actions/app';
import { utilsFunction } from '@/helpers/functions'
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';

class PositionProportionMobile extends React.Component {
    constructor(props) {
        super(props);
        props.innerRef(this);
        this.state = {
            positionProportion: [{ id: 1, title: 'market_position_proportion_title', isActive: false }],
            holdingsList: [
                {title:'market_stocks_and_funds', color:'#d77e52', proportion:'100%'},
                // {title:'market_position_proportion_futures', color:'#44c791', proportion:'0%'},
                // {title:'market_position_proportion_Options', color:'#d54e52', proportion:'0%'},
            ],
            tooltip:null,
            marketValueDataList:null,
            isLoading:true,
        }
    }

    componentDidMount(){
        const {portfolios} = this.props;
        if(portfolios){
            this.getData()
        }
    }

    componentDidUpdate(preProps){
        if (this.props.portfolios !== preProps.portfolios) {
            if(this.props.portfolios){
                this.getData()
            }
        }
        if (this.props.language && preProps.language !== this.props.language) {
            if(this.props.portfolios){
                this.getData()
            }
        }
    }

    // shouldComponentUpdate(nextProps) {
    //     if (this.props.portfolios && JSON.stringify(this.props.portfolios) === JSON.stringify(nextProps.portfolios)) {
    //         return false
    //     }
    //     return true
    // }

    getData = () => {
        const {portfolios,language} = this.props;
        this.setState({
            isLoading:true
        },() => {
            if(portfolios.portfoliosList){
                let marketValueDataList = [];
                const portfoliosList = portfolios.portfoliosList;
                portfoliosList.map(item => {
                    let marketValueData = {};
                    marketValueData.name = item.marketID + '.' + item.stockCode
                    marketValueData.value = item.marketValueClientBase;
                    marketValueDataList.push(marketValueData);
                })
                var tooltip1={
                  trigger: 'item',
                  formatter: (params) => {
                    var data =  marketValueDataList;
                            var total = 0;
                            var tarValue;
                            for (var i = 0, l = data.length; i < l; i++) {
                                total += Number(data[i].value);
                                if (data[i].name == params.data.name) {
                                    tarValue = data[i].value;
                                }
                            }
                      return (
                         params.marker+ params.data.name + '&nbsp;&nbsp;&nbsp;&nbsp;' + `<span style='font-weight:700'>${(utilsFunction.numericalTransformation(params.value,this.props.language))+ ' (' +(tarValue / total * 100).toFixed(2) +  '%)' }<span>`) 
                  },
                  position: function (point, params, dom, rect, size) {
                      return [point[0], point[1]]
                  },
                  confine: true,
                  extraCssText: 'z-index:0'
                }
                this.setState({
                    marketValueDataList: marketValueDataList,
                    isLoading:false,
                    tooltip:tooltip1
                },() => {
                    if(marketValueDataList && this.PositionProportionEChartRef){
                        this.PositionProportionEChartRef.setEChartPieData({
                            series: [{
                                data: marketValueDataList
                            }]
                        })
                    }
                })
            }
        })
    }

    render() { 
        const {positionProportion, holdingsList ,isLoading, marketValueDataList, tooltip, legend} = this.state;
        const {language} = this.props;
        return(
            <>
                <div className='market-position-proportion'>
                    <div className='market-position-proportion-echarts'>
                        <PositionProportionEChart
                                innerRef={e => this.PositionProportionEChartRef = e} 
                                data = {marketValueDataList}
                                tooltip = { tooltip }
                                labelLine={{ show: true }}
                                label={{ show: true, color: this.props.theme == 'light' ? '#000' : '#fff'}}
                                legend={legend}
                            />
                    </div>
                    <div className='market-position-proportion-details'>
                        <span onClick={() => mobileSubLayoutAction.openMarketPositionProportion()}>{language.market_position_proportion_title + ' >'}</span>
                    </div>
                    <div className='market-position-proportion-holdings'>
                        <div className='holdings-title'>
                            <div>{getSafe(() => language.market_position_proportion_holdings)}</div>
                            <div>{getSafe(() => language.market_position_proportion_proportion)}</div>
                        </div>
                        {holdingsList.map(item => 
                            <div className='holdings-data' key={item.title}>
                                <div>
                                    <div style={{background:item.color,width:'10px',height:'10px',marginRight:'10px'}}></div>
                                    <div>{getSafe(() => language[item.title])}</div>
                                </div>
                                <div>{item.proportion}</div>
                            </div>
                        )}
                    </div>
                </div>
            </>
        )
    }
}

export default connect(
    state => ({
        language: state.app.language,
        portfolios: state.trade.portfolios,
        theme: state.app.theme
    }),
    dispatch => ({
        getPortfolioAction: (p, c) => dispatch(getPortfolioAction(p, c))
    })
)(PositionProportionMobile);